import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";

interface GetPassportOAuthUrlResponse {
  url: string;
}

class AuthService {
  async getPassportOAuthUrl(params: URLSearchParams) {
    const { data } = await $axios.get<
      string,
      AxiosResponse<GetPassportOAuthUrlResponse>
    >("/GetPassportOAuthUrl", { params });
    return data;
  }
}

export const authService = new AuthService();
